<template>
  <v-container fluid grid-list-sm>
    <restaurant-management-panel @handleAction="onAction"
                                 :next-period="nextPeriod"/>
  </v-container>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Components, MapActions, MapGetters } from '@/apps/core/helpers/decorators';
import RestaurantManagementPanel from './components/RestaurantManagementPanel.vue';

Component.registerHooks(['beforeRouteEnter']);

@Component
@Components({ RestaurantManagementPanel })
@MapGetters(['predictionPeriodList', 'nextPeriod'])
@MapActions(['addNotification'])
export default class RestaurantManagement extends Vue {
  onAction(routeName) {
    const routeObject = { name: routeName, params: {} };
    if (routeName === 'optimizer') {
      const periodGuid = (this.nextPeriod && this.nextPeriod?.guid) || this.predictionPeriodList[0]?.guid;
      routeObject.params.periodGuid = periodGuid;
    }
    this.$router.push(routeObject);
  }
}
</script>
